import React, {useState, useEffect} from 'react'

import classes from './Logo.module.css'
import logo from "./logo.png"
const Logo = () => {

  return (
    <div className={classes.Logo}>
      <img src={logo} alt="Logo" />
    </div>
  );
};

export default Logo;
